export default function () {
  const elems = document.getElementsByClassName("lang-selector");
  for (const langSelector of elems) {
    langSelector?.addEventListener("click", (event) => {
      langSelector.classList.toggle("_open");
    });
  }
}
